/**
 * Under the failed now line: what a retry changes, in a few words, and the full log one click
 * away (the landing's log in Pipelines for a failed check, the session's timeline for a failed
 * session). The failure itself is the now line; this row never repeats it.
 */
import { ScrollText } from '@orgus/ui/icons';
import { useNavigate } from 'react-router';
import type { Landing } from '@orgus/protocol';
import { Button } from '@orgus/ui';
import type { FailureKind } from './model.ts';

export function RunFailure({ kind, landing, change, onShowSession }: { kind: FailureKind; landing: Landing | null; change: string | null; onShowSession: (() => void) | null }) {
  const navigate = useNavigate();
  const next = kind === 'check' ? (landing?.problem?.next ?? 'Fix the branch, then retry the checks.') : (change ?? 'Retry starts it again like the last start.');
  return (
    <div className="flex min-w-0 items-start gap-3" data-run-failure={kind}>
      {/* Lined up under the now line's words, past its icon. */}
      <span className="w-4 shrink-0" aria-hidden />
      <div className="flex min-w-0 flex-1 flex-wrap items-center gap-x-4 gap-y-2">
      <span className="min-w-0 flex-1 basis-64 text-caption text-fg-subtle">{next}</span>
      {kind === 'check' && landing ? (
        <Button size="sm" variant="ghost" icon={<ScrollText />} onClick={() => navigate(`/pipelines/landing?queue=${encodeURIComponent(landing.queueId)}&landing=${encodeURIComponent(landing.id)}`)}>
          Show the log
        </Button>
      ) : onShowSession ? (
        <Button size="sm" variant="ghost" icon={<ScrollText />} onClick={onShowSession}>
          Show the log
        </Button>
      ) : null}
      </div>
    </div>
  );
}
